module.exports = __webpack_public_path__ + "media/images/evaluation_icon-cea7979c7889096ee0bbc57b248d2b3f.svg";